<template>
  <div class="menu">
    <a href="#" class="contactIdylive" @click.prevent="contact">Contacter Idylive</a>
    <div class="leftMenu">
      <img
        :src="'/assets/icons_' + $store.state.iconTheme + '/menu_mobile.png'"
        @click="toggleMenu"
        class="iconeMenuMobile"
      />
      <img class="menuLogo" src="/assets/images/logo_petit_sv.png" />

      <div class="links">
        <router-link :to="{ name: 'Accueil' }" class="boutonMenu accueil">
          ACCUEIL
        </router-link>
        <router-link :to="{ name: 'Membres' }" class="boutonMenu membres">
          MEMBRES
        </router-link>
        <router-link :to="{ name: 'Recherche' }" class="boutonMenu recherche">
          RECHERCHE
        </router-link>
        <router-link :to="{ name: 'Compte' }" class="boutonMenu compte">
          <span class="mon">MON</span> COMPTE
        </router-link>
        <router-link v-if="admin" :to="{ name: 'Admin' }" class="boutonMenu compte">
          ADMIN
        </router-link>
      </div>
    </div>
    <div class="rightMenu">
      <div class="links">
        <router-link id="friendButton" :to="{ name: 'Favoris' }" class="petitBouton">
          <div class="boutonRond">
            <img :src="'/assets/icons_' + $store.state.iconTheme + '/friends.png'" />
          </div>
          <div class="text">Favoris</div>
        </router-link>

        <router-link :to="{ name: 'Visites' }" class="petitBouton visites" :class="{ light: counters.newVisits != 0 }">
          <div class="boutonRond">
            <img :src="'/assets/icons_' + $store.state.iconTheme + '/visite.png'" />
          </div>
          <div class="text">Visites</div>
          <span v-if="counters.newVisits != 0" class="bulleBouton">{{ counters.newVisits }}</span>
        </router-link>

        <router-link :to="{ name: 'Flash' }" class="petitBouton flashs" :class="{ light: counters.newVisits != 0 }">
          <div class="boutonRond">
            <img ref="flashIcon" :src="'/assets/icons_' + $store.state.iconTheme + '/flash.png'" />
          </div>
          <div class="text">Flash</div>
          <span v-if="counters.newFlashs != 0" class="bulleFlashs bulleBouton">{{ counters.newFlashs }}</span>
        </router-link>

        <router-link
          :to="{ name: 'Messagerie', query: { id: $store.state.lastContact } }"
          class="petitBouton flashs"
          :class="{ light: counters.unreadMessages != 0 }"
        >
          <div class="boutonRond messageRond">
            <img :src="'/assets/icons_' + $store.state.iconTheme + '/mail.png'" />
            <span v-if="counters.unreadMessages.length != 0" class="bulleBouton">
              {{ counters.unreadMessages.length }}
            </span>
          </div>
          <div class="text">Messages</div>
        </router-link>
      </div>
      <div class="progress">
        <MenuProgress v-if="$store.state.profile != null" />
      </div>
    </div>
    <img
      v-if="$store.state.loading"
      :src="'/assets/icons_' + $store.state.iconTheme + '/spinner.gif'"
      class="spinner"
    />
    <div v-show="showMenuMobile" class="menuMobile" ref="menuMobile">
      <div class="links">
        <router-link :to="{ name: 'Accueil' }" class="boutonMenu">
          ACCUEIL
        </router-link>
        <router-link :to="{ name: 'Profil' }" class="boutonMenu">
          MON PROFIL
        </router-link>
        <router-link :to="{ name: 'Membres' }" class="boutonMenu">
          MEMBRES
        </router-link>
        <router-link :to="{ name: 'Recherche' }" class="boutonMenu">
          RECHERCHE
        </router-link>
        <router-link :to="{ name: 'Compte' }" class="boutonMenu compte">
          MON COMPTE
        </router-link>
        <a href="#" @click.prevent="disconnect" class="boutonMenu deco"> DECONNEXION </a>
      </div>
    </div>

    <popup-dialog v-if="contacting">
      <div>
        <div class="contactForm">
          <div><span>Objet: </span> <input v-model="objet" type="text" /></div>
          <div>
            <span>Message: </span>
            <textarea v-model="message" rows="6"></textarea>
          </div>
        </div>
        <div class="boutons">
          <a class="bouton" @click.prevent="sendContact">Envoyer</a>
          <a class="bouton" @click.prevent="contacting = false">Annuler</a>
        </div>
      </div>
    </popup-dialog>

    <popup-dialog v-if="$store.state.promo && $route.name != 'Promo'" :width="'800px'">
      <div class="promoPopup">
        <img :src="$store.state.promo.image" class="imgBt largePromo" @click="$router.push({ name: 'Promo' })" />
        <img :src="$store.state.promo.imageMobile" class="imgBt smallPromo" @click="$router.push({ name: 'Promo' })" />
        <router-link class="bouton" :to="{ name: 'Promo' }">Souscrire</router-link>
        <a class="bouton" @click.prevent="cancelPromo">Non Merci</a>
      </div>
    </popup-dialog>
  </div>
</template>

<script>
import MenuProgress from "@/components/MenuProgress";
import { idyuJsonRpc } from "@/assets/js/idyu/connect.js";
import { idyu_isAdmin } from "@/assets/js/idyu/util.js";
import Vue from "vue";
import PopupDialog from "./util/PopupDialog.vue";

export default {
  name: "Menu",
  components: { MenuProgress, PopupDialog },
  data() {
    return {
      counters: {
        unreadMessages: [],
        newVisits: 0,
        newFlashs: 0,
        newChat: 0
      },
      showMenuMobile: false,
      contacting: false,
      objet: null,
      message: null
    };
  },

  watch: {
    $route: function() {
      this.showMenuMobile = false;
    }
  },

  mounted: async function() {
    Vue.prototype.$counters = this.counters;
    await this.$global.pageInitiated;
    this.$store.state.messager.addListener(this);
    this.$store.state.messager.addAlertListener(this);
    this.counters.unreadMessages = await idyuJsonRpc("countUnreadMessages");
    this.counters.newFlashs = await idyuJsonRpc("countNewFlashs");
    this.counters.newVisits = await idyuJsonRpc("countNewVisits");
  },

  methods: {
    contact() {
      this.contacting = true;
    },

    cancelPromo() {
      this.$store.state.promo = null;
    },

    disconnect: async function() {
      await idyuJsonRpc("destroySession");
      localStorage.login = null;
      localStorage.password = null;
      Vue.$cookies.set("crypt", "");
      window.location = "/";
    },

    async sendContact() {
      idyuJsonRpc("sendEmail", this.$store.state.user.email, this.objet, this.message);
      this.objet = "";
      this.message = "";
      await alert("Votre message a bien été envoyé, nous vous répondrons au plus vite.");
      this.contacting = false;
    },

    toggleMenu: function(e) {
      e.stopPropagation();
      e.preventDefault();
      this.showMenuMobile = !this.showMenuMobile;
    },

    messageReceived: async function(msg) {
      if (msg.data.type === "message") {
        if (
          (this.$route.name === "Messagerie") === false &&
          this.counters.unreadMessages.includes(msg.data.idFrom) === false
        ) {
          this.counters.unreadMessages.push(msg.data.idFrom);
          const prf = await idyuJsonRpc("getProfileSummary", msg.data.idFrom);
          this.$alert.message(prf);
        }
      }
    },

    alertReceived: async function(msg) {
      if (msg.data.type === "flash") {
        if (this.$route.name !== "Flash") this.counters.newFlashs++;
        const prf = await idyuJsonRpc("getProfileSummary", msg.data.idFrom);
        this.$alert.flash(prf);
      }

      if (msg.data.type === "visit") {
        if (this.$route.name !== "Visites") this.counters.newVisits++;
        const prf = await idyuJsonRpc("getProfileSummary", msg.data.idFrom);
        this.$alert.visit(prf);
      }

      if (msg.data.type == "screenShare") {
        const prf = await idyuJsonRpc("getProfileSummary", msg.data.idFrom);
        this.$alert.screenShare(prf);
      }
    },

    hideMenuMobile: function() {
      this.showMenuMobile = false;
    }
  },

  computed: {
    admin() {
      return idyu_isAdmin(this.$store.state.user.pass.permission);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.light {
  .boutonRond {
    filter: none;
  }
}

.menu {
  position: relative;
  width: 100%;
  display: grid;
  grid-template-columns: auto min-content min-content;
  justify-items: start;
  align-items: center;
  border-bottom: 2px #ddd solid;

  height: 70px;
  .spinner {
    position: fixed;
    bottom: 10px;
    right: 10px;
  }
}

.imgBt {
  cursor: pointer;
}

.leftMenu {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 15px;
  align-items: center;
  align-content: flex-end;
  height: 70px;

  .links {
    display: grid;
    grid-auto-flow: column;
    grid-gap: 15px;
    align-items: center;
  }

  .iconeMenuMobile {
    display: none;
  }
}

.rightMenu {
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 10px;
  align-items: center;

  .links {
    display: grid;
    grid-template-columns: auto auto auto auto auto;
    grid-gap: 10px;
    align-items: center;

    a {
      display: grid;
      justify-items: center;
      &:hover {
        .boutonRond {
          filter: none;
        }
      }
    }

    .text {
      height: 20px;
      display: grid;
      align-content: end;
    }
  }
}

img.menuLogo {
  max-height: 50px;
}

.boutonMenu {
  font-weight: bold;
  color: #71789b;
  font-size: 16px;

  &:hover {
    color: $theme_color;
  }
}

.menuMobile {
  position: fixed;
  top: 65px;
  left: 0px;
  background-color: white;
  z-index: 2000;
  border: $light_border;
  box-shadow: $small_shadow;
  min-width: 75%;
  border-left: none;

  .links {
    padding: 10px;
    display: grid;
    grid-template-columns: auto;

    a {
      border-top: $light_border;
      padding-top: 8px;
      padding-bottom: 8px;
      &:last-child {
        border-bottom: $light_border;
      }
    }

    .boutonMenu {
      &:hover {
        color: #71789b;
      }
    }
  }
}

.petitBouton {
  position: relative;
}

.bulleBouton {
  position: absolute;

  border-radius: 50%;
  background-color: black;
  color: white;

  font-weight: bold;
  padding: 2px;
  font-size: 12px;
  display: grid;
  min-width: 15px;
  align-content: center;
  justify-content: center;
  box-shadow: $small_shadow;
}

.flashs .bulleBouton {
  right: -10px;
  top: -5px;
}

.messages .bulleBouton {
  top: -5px;
  right: 4px;
}

.visites .bulleBouton {
  top: -5px;
  right: -5px;
}

.smallPromo {
  display: none;
}

.largePromo {
  display: block;
}

@media screen and (max-width: 1059px) {
  .mon {
    display: none;
  }
}

@media screen and (max-width: 1050px) {
  .leftMenu .links .compte {
    display: none;
  }

  .leftMenu .iconeMenuMobile {
    display: block;
    margin-left: 10px;
  }
}

@media screen and (max-width: 1020px) {
  .leftMenu .links .recherche {
    display: none;
  }
}

@media screen and (max-width: $no_menuprogress) {
  .progress {
    display: none;
  }
}

@media screen and (max-width: 900px) {
  .membres {
    display: none;
  }

  .accueil {
    display: none;
  }

  .leftMenu {
    .links {
      grid-template-columns: auto auto;
    }
  }
}

@media screen and (max-width: 840px) {
  .smallPromo {
    display: block;
  }

  .largePromo {
    display: none;
  }
}

@media screen and (max-width: 530px) {
  .spinner {
    width: 30px;
  }

  .rightMenu {
    margin-right: 0;
  }
}

@media screen and (max-width: $no_menulogo) {
  .leftMenu {
    .menuLogo {
      display: none;
    }
    grid-template-columns: auto;
    grid-gap: 0;
    align-items: center;
    align-content: center;
  }
}

.contactForm {
  display: grid;
  grid-gap: 10px;
  div {
    display: grid;
    grid-template-columns: 100px 1fr;
    grid-gap: 10px;
    text-align: right;
    align-items: baseline;
  }
  textarea {
    height: 150px;
  }
}
.boutons {
  margin-top: 10px;
  display: grid;
  grid-gap: 10px;
}

.disabledMenu {
  color: rgb(189, 189, 189);
  .boutonRond {
    background-color: rgb(231, 226, 226) !important;
    cursor: default;
  }
  img {
    filter: grayscale(1) !important;
    cursor: default;
  }
  &:hover {
    cursor: default;
    color: rgb(189, 189, 189);
  }
}

.promoPopup {
  display: grid;
  grid-gap: 10px;
  justify-content: center;
  a {
    width: 100%;
  }
}
</style>
